<template>
  <div class="room-p">
    <div class="rp-title">
      <Row>
        <Col span="12" class="rp-txt">
        直播产品
        </Col>
        <Col span="12" class="f-tar">
        <Button type="primary" @click.native="showAdd">添加产品</Button>
        </Col>
      </Row>
    </div>
    <div class="rp-content" v-if="proList.length">
      <Row :gutter="20">
        <Col span="8" v-for="(item, index) in proList" ::key="index">
        <div class="rp-item">
          <img :src="item.banner[0]" v-if="item.banner && item.banner[0]">
          <div class="rp-item-modal" @click="delItem(item)">删除</div>
        </div>
        <p class="txt1" :title="item.name">{{ item.name }}</p>
        </Col>
      </Row>
    </div>
    <div class="empty" v-else style="">暂无产品</div>
    <addProduct :show="showProduct" @finish="init()" @close="showProduct = false" :options="proList"
      :modelTitle="modelTitle" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import addProduct from "./add-product.vue"; // 添加/编辑助教
export default {
  components: { addProduct },
  props: {},
  data () {
    return {
      modelTitle: "添加产品",
      showProduct: false,
      page: 1,
      size: 10,
      proList: [],
    };
  },
  watch: {},
  computed: {
    isExhibition () { // 是否时展商入口
      return this.$route.query.isExhibition;
    },
    activityId () {
      return this.$route.query.activityId;
    },
    option () {
      return {
        option: {
          pageIndex: this.page,
          pageSize: this.size,
        },
        channelId: this.channelId
      }
    },
    channelId () {
      return this.$route.query.channelId;
    },
  },
  methods: {
    ...mapActions({
      getAllByChannelId: 'productModule/getAllByChannelId',
      channelProductAll: 'liveModule/channelProductAll',
      removeTransportProduct: 'liveModule/removeTransportProduct',
    }),
    showAdd () {
      // 新增产品
      this.showProduct = true;
      this.modelTitle = "添加产品";
    },
    async delItem (item) {
      console.log(item);
      let bool = await this.removeTransportProduct({
        activityId: this.activityId,
        productId: item.id,
        request: {
          channelId: this.channelId,
          liveProductId: item.liveProductId + '',
        }
      });
      if (bool && bool.data && bool.data.polyv && bool.data.polyv.removeTransportProduct) {
        this.$Message.success("操作成功！");
        setTimeout(c => {
          this.init();
        }, 1000);
      } else {
        let err = "操作失败，请重新尝试";
        if (bool.errors && bool.errors[0]) {
          err = bool.errors[0].message;
        }
        this.$Message.error(err);
      }
    },
    async setAudit (row) {
      const opt = {
        joinIds: [row.joinId]
      };
      const bool = await this.setOneStepAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    async init () {
      if (!this.channelId) return;
      let res = await this.getAllByChannelId(this.option);
      if (!(res && res.items)) return;
      res.items.map(c => {
        if (c.banner) {
          c.banner = JSON.parse(c.banner);
        }
      });
      this.proList = res.items;
      console.log('proList', this.proList);

    }
  },
  created () {
    this.init();
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.room-p {
  background: #fff;
  padding: 20px;
  min-height: 468px;

  .rp {
    &-item {
      width: 100%;
      padding-bottom: 80%;
      position: relative;

      &:hover {
        .rp-item-modal {
          display: block;
        }
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        z-index: 1;
      }

      &-modal {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        margin: auto;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        background-color: rgba(55, 55, 55, .6);
        text-align: center;
        padding-top: calc(50% - 30px);

      }
    }

    &-txt {
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }

    &-title {
      /deep/ .ivu-btn {
        display: inline-block;
        margin-right: 20px;
      }
    }

    &-content {
      margin-top: 20px;
    }
  }
}

.txt1 {
  line-height: 40px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty {
  line-height: 468px;
  text-align: center;
  color: #aaa;
  font-size: 14px;
  background-color: #fff;
}
</style>
